import { memo } from "react";

function PageNotFound() {
  return <p>NotFoundPage</p>;
}

export default memo(PageNotFound);
